import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { messageDrawer } from './stores/messageDrawer';

/**
 * ThreadDetail — deep-link redirect shim.
 *
 * The actual thread UI now lives in `MessageDrawer`, mounted globally in
 * AppLayout. This component exists so existing /app/clinic/:threadId
 * links (email notifications, push, old bookmarks) still resolve: it
 * opens the drawer to the requested thread and bounces to /app/clinic
 * so the URL stays clean.
 */
export function ThreadDetail() {
  const { threadId } = useParams();

  useEffect(() => {
    if (threadId) messageDrawer.openThread(threadId);
  }, [threadId]);

  return <Navigate to="/app/clinic" replace />;
}
